import { createFileRoute } from '@tanstack/react-router';
import Settings from '../../../administration/src/components/Settings';

export const Route = createFileRoute('/_secured/administration/account')({
  component: Settings,
});
